import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'cream' | 'white' | 'forest';
}
export function Section({
  children,
  className,
  id,
  background = 'cream'
}: SectionProps) {
  const bgColors = {
    cream: 'bg-[#FDF8F0]',
    white: 'bg-white',
    forest: 'bg-[#1B4332] text-white'
  };
  return <section id={id} className={cn('py-10 md:py-14 px-4 md:px-6 lg:px-8 overflow-hidden', bgColors[background], className)} data-id="element-247">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-5xl mx-auto" data-id="element-248">
        {children}
      </motion.div>
    </section>;
}